export const QUANTUM_DATASET_IDS = ["FIB25", "LDBC", "MB6"]
